module.exports = __webpack_public_path__ + "static/media/image3.5a703507.JPG";